import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { UserService } from 'src/app/core/services/user.service';
import { RolService } from 'src/app/services/rol.service';
import { TaskCaseFileService } from '../../../services/task-case-file.service';
import { TaskCaseService } from '../../../services/taskCase.service';
import { log } from 'console';
import { ConfirmDeleteComponent } from '../case-files/confirm-delete/confirm-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalFileShowViewComponent } from 'src/app/components/shared/components/modal-file-show-view/modal-file-show-view.component';

@Component({
  selector: 'file-item-task',
  templateUrl: './file-item-task.component.html',
  styleUrls: ['./file-item-task.component.scss'],
})
export class FileItemTaskComponent implements OnInit {
  @Input() file;
  @Input() case;
  @Output() deleteFile = new EventEmitter<string>();
  permisosStr: string = null;
  constructor(
    public rolesService: RolService,
    private readonly userService: UserService,
    private readonly taskCaseFileService: TaskCaseFileService,
    private readonly taskCaseService: TaskCaseService,
    private readonly dialog: MatDialog
  ) {}
  ngOnInit() {
    this.permisosStr = this.rolesService.permisos.toString();
  }
  get canEdit() {
    return this.userService.permissions.editCases;
  }
  get date() {
    return moment(this.file.createdAt).format('d/MM/yyyy h:mm a	 HH:mm');
  }
  get status() {
    return this.case.status == 'archived';
  }
  view() {
        this.dialog
          .open(ModalFileShowViewComponent, {
            data: this.file,
            minWidth: '1%',
          })
          .afterClosed()
          .subscribe(async (re) => {});
  }
  download() {
    const path = this.file.url + `?name=${this.file.name}&download=true`;
    var a = document.createElement('a');
    a.href = path;
    a.download = path.substr(path.lastIndexOf('/') + 1);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  delete() {
    this.dialog
      .open(ConfirmDeleteComponent, {
        width: '400px',
        height: '155px',
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          if (response) {
            this.taskCaseFileService
              .deleteTaskFile(this.file._id)
              .subscribe(() => {
                this.taskCaseService
                  .getTaskCase(this.file.task)
                  .subscribe((task) => {
                    this.deleteFile.emit();
                    this.taskCaseService.taskUpdated.next({ task });
                  });
              });
          }
        },
      });
  }
}
